import type { ReactNode } from "react";

/**
 * Full-screen branded status surface shared by every auth hand-off state
 * (initial load, redirecting, OAuth callback success/error, logout).
 *
 * Renders only the Agentech shell (gradient backdrop + top-bar logo); callers
 * provide the inner status content (spinner/icon + heading + message). The DOM
 * and class names are identical to the previously inlined markup, so this is a
 * pure de-duplication with no visual or behavioural change.
 */
export function AuthStatusScreen({
  children,
  containerClassName = "callback-container",
}: {
  children: ReactNode;
  containerClassName?: string;
}) {
  return (
    <div className={containerClassName}>
      <header className="callback-topbar">
        <img src="/agentech-white-logo.svg" alt="Agentech" className="auth-brand-logo" />
      </header>
      <main className="callback-body">
        <div className="callback-status">{children}</div>
      </main>
    </div>
  );
}
